import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DwSectionComponent, DwContextSubjects, DwMetaDataFormConfig } from '@devwareapps/devware-cap';

@DwSectionComponent({ keyName: 'fitnessProfileTabs', display: 'Participant profile tabs', sectionIcon: 'fa fa-user', hasChildren: true, childrenPropertyName: 'sections' })
@Component({ selector: 'app-profile-tabs', template: `
  <div class="profile-tabs" role="tablist" aria-label="Profile sections">
    <button *ngFor="let tab of sectionConfig.sections; let i = index" type="button" role="tab"
      [id]="id + '-tab-' + i" [attr.aria-controls]="id + '-panel-' + i" [attr.aria-selected]="active === i"
      [attr.tabindex]="active === i ? 0 : -1" (click)="select(i)" (keydown)="navigate($event, i)">{{ tab.tabHeading }}</button>
  </div>
  <section *ngFor="let tab of sectionConfig.sections; let i = index" role="tabpanel"
    [id]="id + '-panel-' + i" [attr.aria-labelledby]="id + '-tab-' + i" [hidden]="active !== i">
    <dw-dynamic-section *ngIf="visited.has(i)" [sectionConfig]="tab.section" [context]="context" [formConfig]="formConfig"
      [formGroup]="formGroup" [submitted]="submitted" [parentIsVisible]="active === i"></dw-dynamic-section>
  </section>`, styles: [`:host { display:block; } .profile-tabs { display:flex; overflow-x:auto; border-bottom:1px solid #dddacf; margin-bottom:1.5rem; }
    button { border:0; background:transparent; white-space:nowrap; padding:1rem 1.25rem; color:var(--dw-color-text-secondary, #626975); border-bottom:3px solid transparent; }
    button[aria-selected=true] { color:var(--dw-color-primary, #086548); border-color:currentColor; font-weight:600; }
    button:focus-visible { outline:2px solid currentColor; outline-offset:-4px; } [hidden] { display:none !important; }`] })
export class ProfileTabsComponent {
    private static nextId = 0;
    id = 'profile-tabs-' + ProfileTabsComponent.nextId++;
    @Input() sectionConfig: any;
    @Input() context: DwContextSubjects;
    @Input() formConfig: DwMetaDataFormConfig;
    @Input() formGroup: FormGroup;
    @Input() submitted: boolean;
    active = 0;
    visited = new Set<number>([0]);
    select(index: number): void { this.visited.add(index); this.active = index; }
    navigate(event: KeyboardEvent, index: number): void {
        const count = this.sectionConfig.sections.length;
        let next = index;
        if (event.key === 'ArrowRight') { next = (index + 1) % count; }
        else if (event.key === 'ArrowLeft') { next = (index + count - 1) % count; }
        else if (event.key === 'Home') { next = 0; }
        else if (event.key === 'End') { next = count - 1; }
        else { return; }
        event.preventDefault(); this.select(next);
        document.getElementById(this.id + '-tab-' + next)?.focus();
    }
}
